module.exports = __webpack_public_path__ + "img/vmcHiring_04222025.586fee0c.jpg";